<script>
import {Dialog} from "vant";
import {getTeacherIdFromSessionStorage} from "@/util/getTeacherId";
import {getIndexPathFromStorage} from "@/util/getInitRoutePath";
import {checkWechatLogin} from "@/util/checkWechatLogin";

const oss = "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/item";
const vip1 = oss + "/live_seat.jpg" + "?random=" + Date.now();

const imgs = ["https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/item/item_2025_seat_1.jpg", "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/item/item_2025_seat_2.jpg", "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/item/item_2025_seat_3.jpg", "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/item/item_2025_seat_4.jpg"];

export default {
  data() {
    return {
      good: null,
      pageHeight: 0,
      pageWidth: 0,
      displayVipImage: vip1,
      resizeBind: this.resize.bind(this),
      teacher_id: "999999",
      goodsList: [],
      isOver: true,
      scrollHelpStatus: false,
      ordinary: oss + "/ordinary_seat.jpg" + "?random=" + Date.now()
    }
  },
  mounted() {
    checkWechatLogin(this.teacher_id);
    this.getGoodsList();
    this.resize();
    window.addEventListener("resize", this.resizeBind);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeBind);
    document.querySelector(".page")?.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    async getGoodsList() {
      let res = await this.$axios.get(`/item/getItemList?teacher_id=${this.teacher_id}`);
      this.goodsList = res.data;
      for (let index = 0; index < this.goodsList.length; index++) {
        this.goodsList[index]['cover'] = imgs[index]
      }
      this.loadImages(this.goodsList.map(e => e.cover));
    },
    onScroll(e) {
      // 滚动到底
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight + 150 || e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 155) {
        this.scrollHelpStatus = false;
      }
    },
    async loadImages(imageUrls) {
      try {
        const images = await Promise.all(imageUrls.map(url => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Image failed to load: ${url}`));
            img.src = url;
          });
        }));
        let rect = document.querySelector(".img-list").getBoundingClientRect();
        this.scrollHelpStatus = rect.height > this.pageHeight + 150;
        let contentEl = document.querySelector(".page");
        contentEl.addEventListener("scroll", this.onScroll);
        // 在这里执行你需要进行的操作
      } catch (error) {
        console.error('图片加载失败', error);
      }
    },
    resize() {
      const tabbarSize = document.querySelector(".van-tabbar").getBoundingClientRect();
      const headerSize = document.querySelector(".van-nav-bar").getBoundingClientRect();
      const pageHeight = window.innerHeight;
      this.pageWidth = window.innerWidth;
      const currentPageHeight = pageHeight - tabbarSize.height - headerSize.height;
      console.log(currentPageHeight);
      this.pageHeight = currentPageHeight;
    },
    onClickScrollHelp() {
      let el = document.querySelector(".page");
      if(!el) return;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      })
    },
    buyClick(good) {
      // this.$emit("buyClick", good);
      switch (good.jump_type) {
        case 1:
          this.$router.push({
            name: "pay",
            query: {
              id: good.id,
              teacher_id: this.teacher_id,
            },
          });
          break;
        case 2:
          window.location.href = good.jump_param;
          break;
        default:
          Dialog.alert({
            title: "商品跳转参数异常",
          }).then(() => {
            this.$router.replace(getIndexPathFromStorage());
          });
          break;
      }
    }
  }
}
</script>


<template>
  <div class="page" :style="{height: pageHeight + 'px'}">
    <div v-if="!isOver" class="content">
      <div class="img-list">
        <!--      <img :src="displayVipImage" @click="buyClick(goodsList[0])" :style="{height: pageHeight * 0.5 - 5 + 'px'}">-->
        <!--      <img :src="ordinary" @click="buyClick(goodsList[1])" :style="{height: (pageHeight * 0.5) - 5 + 'px'}">-->
        <!--      :style="{height: (pageHeight * 0.25) - 5 + 'px'}"-->
        <img v-for="(item, i) in goodsList" :key="i" @click="buyClick(item)" :src="item.cover" alt="">
      </div>
      <div class="scroll-help flex items-center justify-center fixed w-full left-0" v-if="scrollHelpStatus" @click="onClickScrollHelp">
        <p>
          <span>上滑查看更多</span>
        </p>
      </div>
    </div>
    <div v-else>
      <div class="h-full flex flex-col items-center justify-center overflow-hidden py-3">
          <p class="mt-10 text-2xl font-bold">报名结束</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  width: 100%;
  object-fit: fill;
}

.page {
  @apply px-3;
  overflow-y: auto;
}

.scroll-help {
  bottom: 50px;
  padding: 10px;
  background-color: rgba(255,255,255,1);
  color: #000;
}
</style>